import React from 'react';

export const PublicFooter = () => {
  return (
    <div className="footer m-auto max-w-[30rem] flex-[0] self-end py-8 text-center">
      <p className="copyright text-xs">Copyright ® {(new Date()).getFullYear()} All Rights Reserved.</p>
    </div>
  );
};
